import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import TeacherCard from '../../components/cards/TeacherCard';

const Teachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await api.get('/teachers');
        setTeachers(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching teachers:', error);
        // Fallback to mock data if API fails
        setTeachers([
          {
            _id: 1,
            userId: { name: 'John Doe', email: 'john@example.com', phone: '+1234567890' },
            employeeId: 'EMP001',
            designation: 'Professor',
            department: 'Computer Science',
            qualification: 'PhD in Computer Science',
            experience: 10,
            avatar: ''
          },
          {
            _id: 2,
            userId: { name: 'Jane Smith', email: 'jane@example.com', phone: '+1234567891' },
            employeeId: 'EMP002',
            designation: 'Assistant Professor',
            department: 'Mathematics',
            qualification: 'MSc Mathematics',
            experience: 5,
            avatar: ''
          },
          {
            _id: 3,
            userId: { name: 'Robert Johnson', email: 'robert@example.com', phone: '+1234567892' },
            employeeId: 'EMP003',
            designation: 'Lecturer',
            department: 'Physics',
            qualification: 'MSc Physics',
            experience: 3,
            avatar: ''
          }
        ]);
        setLoading(false);
      }
    };
  
    fetchTeachers();
  }, []);

  const filteredTeachers = filter === 'All' 
    ? teachers 
    : teachers.filter(teacher => teacher.department === filter);

  const departments = ['All', ...new Set(teachers.map(t => t.department))];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-2xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">Our Faculty</h1>
        
        {/* Department Filter */}
        <div className="mb-8 text-center">
          <div className="inline-block">
            <label className="mr-2 text-gray-700">Filter by Department:</label>
            <select
              className="border rounded p-2"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              {departments.map(dept => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Teachers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredTeachers.map((teacher) => (
            <TeacherCard key={teacher._id} teacher={teacher} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Teachers;